import { render, staticRenderFns } from "./twitter.vue?vue&type=template&id=bb6e9438&scoped=true&"
import script from "./twitter.vue?vue&type=script&lang=ts&"
export * from "./twitter.vue?vue&type=script&lang=ts&"
import style0 from "./twitter.vue?vue&type=style&index=0&id=bb6e9438&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6e9438",
  null
  
)

export default component.exports